import useTitanApp from "../../../hooks/useTitanApp";
import {
  addPatientCondtionRelated,
  getPatientConditionRelated,
  setShowAddPatientConditionModal,
  setCurrentPatientConditionRelatedToEdit,
} from "../../../dispatchers/patientDispatchers";
import { Modal } from "react-bootstrap";
import { IoClose } from "react-icons/io5";
import { useRef, useState } from "react";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import CustomSelectionDropdown from "../../controls/CustomSelectionDropdown";

export default function PatientAddConditionRelatedModal() {
  const [buttonsDisabled, setButtonsDisabled] = useState(false);

  const { appState, patientState } = useTitanApp();
  const { darkMode } = appState || {};
  const {
    selectedPatientDetails,
    showAddConditionRelatedModal,
    addPatientConditionRelatedLoader,
    isConditionRelatedEditMode,
    selectedPatientConditionRelated,
    consultationId
  } = patientState || {};
  const formikRef = useRef();

  const closeModal = () => {
    setShowAddPatientConditionModal(false);
    if (isConditionRelatedEditMode) {
      setCurrentPatientConditionRelatedToEdit(null);
    }
  };
  const initialValues = {
    ConditionName: selectedPatientConditionRelated?.conditionName || "",
    Status: selectedPatientConditionRelated
      ? selectedPatientConditionRelated?.status?.toString() || ""
      : "",
    DiagnosedDate: selectedPatientConditionRelated
      ? selectedPatientConditionRelated?.diagnosedDate != null
        ? new Date(selectedPatientConditionRelated?.diagnosedDate)
            .toISOString()
            .split("T")[0]
        : ""
      : "",
    AdditionalNotes: selectedPatientConditionRelated?.additionalNotes || "",
  };

  const validationSchema = Yup.object({
    ConditionName: Yup.string().required("Condition Name is required"),
    Status: Yup.string().required("Status is required"),
    DiagnosedDate: Yup.date().nullable(), // Optional
    AdditionalNotes: Yup.string().nullable(), // Optional
  });

  const handleAddClick = async (values) => {
    setButtonsDisabled(true);
    let relatedConditions = [];
    const patientCondition = {
      conditionName: values.ConditionName,
      status: values.Status === "" ? null : Number(values.Status),
      diagnosedDate: values.DiagnosedDate === "" ? null : values.DiagnosedDate,
      additionalNotes: values.AdditionalNotes,
    };
    if (isConditionRelatedEditMode) {
      relatedConditions.push(selectedPatientConditionRelated);
    }
    relatedConditions.push(patientCondition);
    const patientRelatedConditions = {
      consultationId,
      patientId: selectedPatientDetails?.patientID,
      relatedConditions: relatedConditions,
    };

    await addPatientCondtionRelated(patientRelatedConditions);
    await getPatientConditionRelated(selectedPatientDetails?.patientID);
    closeModal();
  };

  const statusOptions = [
    { value: "2", label: "Active" },
    { value: "1", label: "Chronic" },
    { value: "3", label: "Resolved" },
  ];

  return (
    <Modal
      show={showAddConditionRelatedModal}
      onHide={closeModal}
      centered
      backdrop="static"
      dialogClassName="pc-modal"
      size="md"
    >
      <div className="header">
        <div className="info pc-add-condition-related-modal-header-info">
          <div className="icon-box">
            <div className="dot"></div>
          </div>
          <p className="label">
            {isConditionRelatedEditMode ? "Edit" : "Add"} Medical Condition
          </p>
          <p className="desc"></p>
        </div>
        <IoClose
          size={20}
          color={darkMode ? "#bdbdbd" : "#7c7c7c"}
          onClick={closeModal}
        />
      </div>

      <div className="body" id="bodyID">
        <Formik
          innerRef={formikRef}
          enableReinitialize
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleAddClick}
        >
          {({ values, errors, touched, handleChange, setFieldValue }) => (
            <Form>
              <div className="fields-wrapper">
                <div className="form-group">
                  <label>Condition Name *</label>
                  <input
                    type="text"
                    name="ConditionName"
                    value={values.ConditionName}
                    onChange={handleChange}
                    placeholder="e.g., Diabetes, Hypertension, Asthma"
                    autoComplete="off"
                    autoFocus
                  />
                  {touched.ConditionName && errors.ConditionName && (
                    <p className="field-error">{errors.ConditionName}</p>
                  )}
                </div>
                <div className="form-group">
                  <CustomSelectionDropdown
                    label="Status *"
                    name="Status"
                    value={values.Status}
                    options={statusOptions}
                    onChange={handleChange}
                  />
                  {touched.Status && errors.Status && (
                    <p className="field-error">{errors.Status}</p>
                  )}
                </div>
                <div className="form-group">
                  <label>Diagnosed Date (optional)</label>
                  <input
                    type="date"
                    name="DiagnosedDate"
                    value={values.DiagnosedDate}
                    onChange={handleChange}
                  />
                </div>
                <div className="form-group">
                  <label>Additional Notes (optional)</label>
                  <input
                    className="template_input text_input_field"
                    type="text"
                    name="AdditionalNotes"
                    value={values.AdditionalNotes}
                    onChange={handleChange}
                    autoComplete="off"
                    placeholder="Treatment details, medications, etc."
                  />
                </div>
              </div>

              <div className="footer-actions">
                <button className="cancel" type="button" onClick={closeModal}>
                  Cancel
                </button>
                <button
                  className="done"
                  type="submit"
                  disabled={buttonsDisabled}
                >
                  {isConditionRelatedEditMode
                    ? addPatientConditionRelatedLoader
                      ? "Updating Condition..."
                      : "Update Condition"
                    : addPatientConditionRelatedLoader
                    ? "Adding Condtion..."
                    : "Add Condition"}
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </Modal>
  );
}
